import React, {useState, useCallback, useRef} from 'react';
// import ReactDOM from 'react-dom';
import {openModal, closeAll} from '../utils/Modal'
import ModalSignin from './ModalSignin'

const ModalJob = () => {

  const videoRef = useRef();
  const [paused, setPaused] = useState(false)

  const pauseToggle = useCallback(
    () => {
      setPaused((state) => !state);
      videoRef.current.paused ? videoRef.current.play() : videoRef.current.pause()
    },
    [],
  );

  const [viewMore, setViewMore] = useState(false);

  const viewMoreToggle = useCallback(
    () => {
      setViewMore((state) => !state)
    },
    [],
  )

  // const renderContent= useCallback(
  //   () => {
      return (
      <section className="modal-job">
        <button className="close-overlay" onClick={() => closeAll()}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.5 1.5L1.5 10.5" stroke="#070E11" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M1.5 1.5L10.5 10.5" stroke="#070E11" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        </button>
        <div className="job">
          <div className="job-header">
            <button className="back-mob" onClick={() => closeAll()}>
              <img src="/img/jobs/left-arrow.svg" alt=""/>
            </button>
          </div>
          <div className="job-main">
            <div className="flex-row no-margin">
              <div className="job-intro">
                <div className="intro-video">
                  <video ref={videoRef} src="/video/video-3.mp4" alt=""/>
                  <div className="no-video" style={{display : "none"}}>
                    <p>No Video description available for this job</p>
                  </div>
                  <button type="button" className={`play-button ${paused ? 'pause' : ''}`} onClick={pauseToggle}/>
                </div>
                <div className="flex-row no-margin justify-content-between">
                  <h5 className="col-6">Job type </h5>
                  <p className="col-6">Full time</p>
                </div>
                <div className="flex-row no-margin justify-content-between">
                  <h5 className="col-6">Salary </h5>
                  <p className="col-6">1,00,000 - 2,20,000</p>
                </div>
                <div className="flex-row no-margin justify-content-between">
                  <h5 className="col-6">Posted on </h5>
                  <p className="col-6">03 June 2021 </p>
                </div>
                <div className="flex-row no-margin justify-content-between">
                  <h5 className="col-6">No of openings </h5>
                  <p className="col-6">06</p>
                </div>
                <div className="flex-row no-margin justify-content-between">
                  <h5 className="col-6">Experience </h5>
                  <p className="col-6">02+ years</p>
                </div>
              </div>
              <div className="job-name">
                <div className="flex-row no-margin align-items-center">
                  <img src="/img/jobs/google.svg" alt="" className="job-logo modal-logo"/>
                  <div className="job-heading">
                    <h4>Product Manager</h4>
                    <p className="job-detail">London, UK</p>
                  </div>
                </div>
                <h5 className="icon border-top">
                  <img src="/img/jobs/lightening.svg" alt=""/>
                  Skills
                </h5>
                <div className="flex-row no-margin">
                  <p className="tag">Node JS</p>
                  <p className="tag">Front-End</p>
                  <p className="tag">JAMStack</p>
                  <p className="tag">React</p>
                  <p className="tag">API</p>
                  <p className="tag more">+4 more</p>
                </div>
                <h5 className="icon perks">
                  <img src="/img/jobs/drop.svg" alt=""/>
                  Perks
                </h5>
                <p>Upto 2% equity, Flexible work timings, No leave policy : just drop a message and take your time off :)</p>
              </div>
            </div>
          </div>
          <div className="job-description">
            <h5 className="icon">
              <img src="/img/jobs/briefcase.svg" alt=""/>
              Job description
            </h5>
            <p>Google is a product development based design firm based out of Austin. At Google we are helping startups &amp; established businesses roll out their next product/service (from prototype to launch), revamp their digital presence and work with the product teams to increase product adoption.</p>
            <p>We are a team of passionate UX UI designers, product managers, web developers and communication artists helping businesses of all sizes including Titan, Google Onduo, <span className={`hidden ${viewMore ? 'show' : ''}`}>DHL to name a few.</span> <a href="#!" onClick={viewMoreToggle}>{`View ${viewMore ? 'less' : 'more'}`}</a>
            </p>
          </div>
          <div className="job-recruiters">
            <h5 className="icon">
              <img src="/img/jobs/opening-icon.svg" alt=""/>
              Recruiters
            </h5>
            <div className="flex-row no-margin">
              <div className="recruiter-card">
                <div className="flex-row no-margin align-items-center">
                  <img src="/img/jobs/recruiter-1.png" alt=""/>
                  <div>
                    <h5>Marvin McKinney</h5>
                    <p>Senior Manager</p>
                  </div>
                </div>
              </div>
              <div className="recruiter-card">
                <div className="flex-row no-margin align-items-center">
                  <img src="/img/jobs/recruiter-2.png" alt=""/>
                  <div>
                    <h5>Jacob Jones</h5>
                    <p>HR</p>
                  </div>
                </div>
              </div>
              <div className="recruiter-card">
                <div className="flex-row no-margin align-items-center">
                  <img src="/img/jobs/recruiter-3.png" alt=""/>
                  <div>
                    <h5>Cameron Williamson</h5>
                    <p>Product Manager</p>
                  </div>
                </div>
              </div>
              <div className="recruiter-card">
                <div className="flex-row no-margin align-items-center">
                  <img src="/img/jobs/recruiter-4.png" alt=""/>
                  <div>
                    <h5>Darlene Robertson</h5>
                    <p>Senior Recruiter</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button type="button" className="button button-purple apply-button" onClick={() => {closeAll();
             setTimeout(() => openModal(<ModalSignin />), 0)
             }}>
            Join Cliphire to Apply to this job
          </button>
        </div>
      </section>
      )
  //   },
  //   [modalShow, ModalToggle],
  // )

  // return (<>
  //    {ReactDOM.createPortal(renderContent(), document.getElementById('modal'))}
  //   </>
    
  // );
};

export default ModalJob;
